// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css';
import './styles/common.css';
import './styles/custom.css';
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import common from './utils/common'
import cookies from 'vue-cookies'

import VueKindEditor from './utils/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all-min.js'
import '../static/kindeditor/lang/zh-CN.js'
Vue.use(VueKindEditor)

Vue.config.productionTip = false

Vue.use(ElementUI, cookies, { size: 'small', zIndex: 3000 })

Vue.prototype.axios = axios
Vue.prototype.moment = moment

Vue.prototype.common = common

axios.get('./static/config.json?v=20210519.01').then((res) => {
  Vue.prototype.BASE_API = res.data.BASE_API;
  Vue.prototype.CONTACT = res.data.CONTACT;
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})
//Vue.prototype.cookies = cookies

/* eslint-disable no-new */


//导航守卫
//router.beforeEach((to, from, next) => {
//    let islogin = $cookies.get('token');
//    //islogin = Boolean(Number(islogin));

//    if(to.path == "/login"){
//        if(islogin){
//            next("/index");
//        }else{
//            next();
//        }
//    }else{
//        // requireAuth:可以在路由元信息指定哪些页面需要登录权限
//        if(to.meta.requireAuth && islogin) {

//            router.addRoutes()

//            next({ ...to, replace: true })
//        //next();

//        }else{
//            next("/login");
//}
//}
//})

//// main.js
//router.beforeEach((to, from, next) => {
//    if (store.getters.token) { // 判断是否有token
//        if (to.path === '/login') {
//            next({ path: '/' });
//        } else {
//            if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
//                store.dispatch('GetInfo').then(res => { // 拉取info
//                    const roles = res.data.role;
//                    store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
//                      router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
//                        next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//                })
//            }).catch(err => {
//                console.log(err);
//            });
//        } else {
//          next() //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
//    }
//}
//} else {
//    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
//    next();
//} else {
//      next('/login'); // 否则全部重定向到登录页
//}
//}
//});

// main.js
//router.beforeEach((to, from, next) => {
//    if ($cookies.get('token')) { // 判断是否有token
//        if (to.path === '/login') {
//            next({ path: '/' });
//        } else {
//            if (true) { // 判断当前用户是否已拉取完user_info信息
//                router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
//                next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record               
//            } else {
//                next() //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
//            }
//        }
//    } else {
//        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
//            next();
//        } else {
//            next('/login'); // 否则全部重定向到登录页
//        }
//    }
//});




// WEBPACK FOOTER //
// ./src/main.js